<template>
  <base-dialog :show-close="true" :visible.sync="visible" width="700px" class="format-dialog">
    <template v-slot:header>限定输入格式</template>
    <div class="format">
      <div class="format-list">
        <div style="margin-bottom: 10px">选择下方常用表达式或自定义输入</div>
        <div
          class="item"
          v-for="(item, index) in commonExpressions"
          :key="index"
          @click="getFormat(item)"
        >
          {{ item.label }}
        </div>
      </div>
      <div class="format-setting">
        <div class="format-item">
          <div class="title">{{ title }}</div>
          <el-input type="textarea" :rows="2" v-model="regexInfo"></el-input>
        </div>
        <div class="format-item">
          <div class="title">测试</div>
          <el-input v-model="testInfo" :class="{ 'required-hint': !result }"></el-input>
          <span class="test-result" :style="!result ? 'color: #F56C6C' : ''">
            {{ testResult }}
          </span>
        </div>
      </div>
    </div>
    <template v-slot:footer>
      <span class="dialog-footer">
        <base-button @click="cancel">取消</base-button>
        <base-button type="primary" @click="submit">保存</base-button>
      </span>
    </template>
  </base-dialog>
</template>

<script>
import BaseDialog from "@/components/BaseComponents/Dialog"
import BaseButton from "@/components/UIComponents/Button"

export default {
  name: "FormatDialog",
  components: {
    BaseDialog,
    BaseButton
  },
  props: {
    regex: String,
    commonExpressions: Array
  },
  data() {
    return {
      visible: false,
      regexInfo: "",
      testInfo: ""
    }
  },
  computed: {
    title() {
      let expression = this.commonExpressions.find(item => item.expression === this.regexInfo)
      if (expression === undefined) return "正则表达式：自定义"
      else return "正则表达式：" + expression.label
    },
    result() {
      let result = true
      if (this.regexInfo && this.testInfo) {
        const reg = "/" + this.regexInfo + "/"
        if (!eval(reg).test(this.testInfo)) {
          result = false
        }
      }
      return result
    },
    testResult() {
      let result = ""
      if (this.regexInfo && this.testInfo) {
        const reg = "/" + this.regexInfo + "/"
        if (!eval(reg).test(this.testInfo)) {
          result =
            "不符合" + (this.title === "正则表达式：自定义" ? "" : this.title.slice(6)) + "格式要求"
        } else result = "测试通过"
      }
      return result
    }
  },
  methods: {
    open() {
      this.regexInfo = this.regex
      this.visible = true
    },
    submit() {
      this.$emit("submit", this.regexInfo)
      this.visible = false
    },
    cancel() {
      this.visible = false
    },
    getFormat(format) {
      this.regexInfo = format.expression
    }
  }
}
</script>

<style lang="scss" scoped>
.format-dialog {
  .format {
    display: flex;
    .format-list {
      border-right: 2px solid #f5f5f5;
      padding-top: 10px;
      width: 240px;
      .item {
        color: #606266;
        margin-bottom: 10px;
        &:hover {
          color: #1989fa;
        }
      }
    }
    .format-setting {
      flex: 1;
      margin: 10px;
      .format-item {
        margin-bottom: 20px;
        .title {
          font-weight: 500;
          color: #606266;
          margin-bottom: 10px;
        }
        .test-result {
          margin-top: 4px;
          font-size: 12px;
        }
      }
    }
    .required-hint {
      ::v-deep {
        .el-input__inner {
          border-color: #f56c6c;
        }
      }
    }
  }
}
</style>
